import { CreditorSearchResultModel } from "../Types";

export const CreditorSearchModel: CreditorSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
